import {useEffect} from "react";

import {GuideStateApi} from "@repo/guide-state";

import {GUIDE_ACKNOWLEDGEMENT_PROMO_NAME} from "../constants.ts";
import {usePromotionQuery} from "../queries/use-promotion-query.ts";

/**
 * Update the state indicating if the AI Guide usage terms have been accepted.
 *
 * This hook refreshes via a GraphQL query the state of whether or not a user
 * has accepted the ai terms.
 */
export function useUpdateTermsAcknowledgementEffect(): void {
    // Check to see if a user has accepted the guide acknowledgement for
    // AIGuide terms. We skip the query if the state indicates that the user
    // has already accepted the terms - this makes testing easier as by setting
    // that state, the query is skipped entirely
    const hasAcceptedAcknowledgementQueryResult = usePromotionQuery(
        GUIDE_ACKNOWLEDGEMENT_PROMO_NAME,
        GuideStateApi.latest().hasAcknowledgedGuide,
    );

    // Update the current state if the promo query has resolved
    useEffect(() => {
        if (hasAcceptedAcknowledgementQueryResult) {
            GuideStateApi.set("hasAcknowledgedGuide", true);
        }
    }, [hasAcceptedAcknowledgementQueryResult]);
}
